import {
    Grid,
    Typography,
    WithStyles,
    withStyles,
    CardHeader,
    IconButton,
  } from "@material-ui/core";
  import { Link } from 'react-router-dom';
  import React, { Component, ReactNode } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../styles";
  import {
    switchSelectedTab,setRolesTab,setUsersTab,setClientTab
  } from "../actions/userActions";
  import CloseIcon from '@material-ui/icons/Close';
  
  interface DialogHeaderProps extends WithStyles<typeof userStyles> {
    headerTitle: string;
    iconNode: ReactNode;
    urlName: string;
    switchSelectedTab: any;
    setRolesTab: any;
    setUsersTab: any;
    setClientTab: any;
    selectedTab?: any;
  }
  
  class DialogHeader extends Component<DialogHeaderProps> {
    constructor(props:DialogHeaderProps){
		super();
    }  
    
    dialogCloseHandler = () => {
      this.props.switchSelectedTab(this.props.selectedTab);
      if(this.props.selectedTab === "Roles") {
        this.props.setRolesTab(true)
      }
      if(this.props.selectedTab === "Users") {
        this.props.setUsersTab(true)
      }
      if(this.props.selectedTab === "Clients") {
        this.props.setClientTab(true)

      }
    }

    render() {
        const { headerTitle, iconNode, urlName, classes } = this.props;

      return (
        <>
        <CardHeader
                className={classes.modalHeader}
                action={
                  <Link to={this.props.urlName} style={{ textDecoration: 'none' }}
                  onClick={this.dialogCloseHandler}
                  >
                    {this.props.iconNode}
                  </Link>
                }
                title={
                  <Typography
                    align="left"
                    className={[
                      classes.fontWeight500,
                      classes.title,
                      classes.fontSizeLG,
                    ].join(' ')}
                  >
                    {this.props.headerTitle}
                  </Typography>
                }
              />
        </>
      );
    }
  }
  const mapStateToProps = (state: any) => ({
  });

  const mapDispatchToProps = {
    switchSelectedTab,
    setRolesTab,
    setUsersTab,
    setClientTab
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
      // @ts-ignore
  )(withStyles(userStyles)(DialogHeader));
  